
import { regrasEncantation } from '../../../mocks/worksheet-encantations';

export default function RegrasOuro() {
  return (
    <section id="regras" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-5">
            <div className="w-12 h-px bg-[#D4AF37]/40"></div>
            <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-[#D4AF37]">
              Fundamentos Essenciais
            </span>
            <div className="w-12 h-px bg-[#D4AF37]/40"></div>
          </div>
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-5">
            As 6 Regras de <span className="text-[#D4AF37] italic">Ouro</span>
          </h2>
          <p className="font-['Montserrat'] text-base text-[#6A6A6A] max-w-2xl mx-auto leading-relaxed">
            Antes de criar suas Encantations, domine estas regras fundamentais.
            Cada uma é essencial para que a técnica funcione com máximo poder.
          </p>
        </div>

        {/* Grid de Regras */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {regrasEncantation.map((regra) => (
            <div
              key={regra.numero}
              className="group relative bg-[#FAF8F5] rounded-2xl p-7 border border-[#D4AF37]/10 hover:border-[#D4AF37]/30 transition-all duration-400 hover:shadow-lg hover:-translate-y-1"
            >
              {/* Número */}
              <div className="absolute -top-3 -left-1 w-10 h-10 bg-gradient-to-br from-[#D4AF37] to-[#B8941E] rounded-full flex items-center justify-center shadow-md">
                <span className="font-['Playfair_Display'] text-sm font-bold text-white">{regra.numero}</span>
              </div>

              {/* Ícone */}
              <div className="w-14 h-14 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center mb-5 group-hover:bg-[#D4AF37]/20 transition-colors">
                <i className={`${regra.icone} text-2xl text-[#D4AF37]`}></i>
              </div>

              <h3 className="font-['Playfair_Display'] text-xl font-bold text-[#1A1A1A] mb-3">
                {regra.titulo}
              </h3>

              <p className="font-['Montserrat'] text-sm text-[#5A5A5A] leading-relaxed mb-4">
                {regra.descricao}
              </p>

              {/* Exemplo */}
              <div className="bg-white rounded-lg p-3 border border-[#D4AF37]/10">
                <p className="font-['Montserrat'] text-xs text-[#8A8A8A] mb-1 uppercase tracking-wider">Exemplo:</p>
                <p className="font-['Montserrat'] text-sm text-[#D4AF37] font-medium italic">
                  {regra.exemplo}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
